export default "__VITE_ASSET__kzRbz3Jj__"